/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import client from "./client";

/** Session-cookie auth, same as the rest of drive. `service` scopes to this app. */
export const listNotifications = async ({ pageNumber = 1, pageSize = 20, isRead } = {}) => {
  const { data } = await client.get("/notifications", {
    params: {
      page_number: pageNumber,
      page_size: pageSize,
      is_read: isRead,
      service: "drive",
    },
  });
  return { notifications: data.notifications || [], count: data.count ?? 0 };
};

export const getUnreadCount = async () => {
  const { data } = await client.get("/notifications/unread_count");
  return data.unread_count ?? 0;
};

export const markAllRead = () =>
  client.post("/notifications/mark_all_read").then((r) => r.data);

export const markRead = (id) =>
  client.patch(`/notifications/${id}/read`).then((r) => r.data);
